// UI feedback only: never retries, cancels or changes the outcome of a request.
const pending = new Map();
const listeners = new Set();
let nextId = 0;
let snapshot = { count: 0, writes: 0 };

function publish() {
  snapshot = { count: pending.size, writes: [...pending.values()].filter(Boolean).length };
  listeners.forEach(listener => listener());
}

export const requestActivity = {
  subscribe(listener) { listeners.add(listener); return () => listeners.delete(listener); },
  getSnapshot() { return snapshot; },
  begin(method = 'get') {
    const id = ++nextId;
    pending.set(id, !['get', 'head', 'options'].includes(method.toLowerCase()));
    publish();
    return id;
  },
  finish(id) { if (pending.delete(id)) publish(); },
};

export function installRequestActivity(client) {
  const start = client.interceptors.request.use(config => {
    if (config.loadingIndicator !== false) config._uiActivityId = requestActivity.begin(config.method);
    return config;
  });
  const finish = client.interceptors.response.use(response => {
    requestActivity.finish(response.config?._uiActivityId);
    return response;
  }, error => {
    requestActivity.finish(error.config?._uiActivityId);
    return Promise.reject(error);
  });
  return () => {
    client.interceptors.request.eject(start);
    client.interceptors.response.eject(finish);
  };
}
